// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CapsuleitemScreenLayout} from 'app_components/screens/landing/capsuleitem'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PostService from 'app_services/campus/postService'
// @end

// @import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @ADD Component types
interface ICapsuleitemScreenProps {
  capsuleData: any
  match?: any
}
interface ICapsuleitemScreenState {
  post: IPost | null
  loading: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CapsuleitemScreen extends Component<ICapsuleitemScreenProps, ICapsuleitemScreenState> {

  private postService: PostService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICapsuleitemScreenProps) {
    super(props)
    this.state = {
      post: null,
      loading: true,
    }
    this.postService = new PostService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.match?.params?.slug) {
      await this.getPost(this.props?.match?.params?.slug)
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = async (before: any, after: any) => {
    if (this.props?.match?.params?.slug !== before?.match?.params.slug) {
      await this.getPost(this.props?.match?.params?.slug)
    }
  }

  // @Add custom methods
  getPost = async (slug: string) => {
    this.setState({ loading: true })

    let post: any = null

    const newsResponse = await this.postService.fetchPost(slug)

    if (newsResponse && newsResponse.post) {
      post = newsResponse.post
    }

    this.setState({
      post,
      loading: false
    })
  }

  render() {
    return(
      <CapsuleitemScreenLayout
        post={this.state.post}
        loading={this.state.loading}
      />
    )
  }
}

export default connect(mapStatesToProps)(CapsuleitemScreen)
